export const validateFileName = (value) => {
  const patter = new RegExp(/^[A-Za-z0-9]+$/g);
  const fileName = value.split(".");

  if (fileName.length > 2) return false;

  return patter.test(fileName[0]);
};
